/**
 * Insurance Portal Adapter
 * API spec for external links
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface LinkDto {
  code: string;
  group: LinkDtoGroupEnum;
  target?: LinkDtoTargetEnum;
  authType?: LinkDtoAuthTypeEnum;
  translationKey: string;
  url: string;
}
export enum LinkDtoGroupEnum {
  Sidebar = 'SIDEBAR',
  Footer = 'FOOTER',
}
export enum LinkDtoTargetEnum {
  Iframe = 'IFRAME',
  Blank = 'BLANK',
  Self = 'SELF',
}
export enum LinkDtoAuthTypeEnum {
  None = 'NONE',
  MaterialsManagementDe = 'MATERIALS_MANAGEMENT_DE',
}
